// Checks if all properties on the passed in object are null (true), else return false.
// EDIT:
// Allows priority value to be 'relative' or null and it will still return true.
// This is because opening and saving other values in the key dates modal will auto-default that to 'relative'
// which is OK, if the other values are still untouched

export function objectPropertiesAllNull(obj: { [key: string]: any }): boolean {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (key === 'priority' && obj[key] !== null && obj[key] !== 'relative') {
        return false;
      } else if (key !== 'priority' && obj[key] !== null) {
        return false;
      }
    }
  }
  return true;
}
